import { useConfig } from "../context/config-context";

export default function NotFound() {
  const siteConfig = useConfig();
  return (
    <div className="flex items-center justify-center w-full h-screen bg-gray-100">
      <div className="text-center">
        <p className="text-2xl font-semibold text-primary">Page Non Trouvée</p>
        <h1 className="mt-2 text-6xl font-bold text-secondary">404</h1>
        <p className="mt-4 text-lg text-gray-700">
          {siteConfig.components.not_found.label}
        </p>
        <a
          href={siteConfig.routes.dashboard.path}
          className="inline-block px-6 py-2 mt-6 text-sm font-semibold text-white rounded bg-primary hover:bg-light hover:text-white"
        >
          {siteConfig.components.not_found.cta}
        </a>
      </div>
    </div>
  );
}
